import React, { useState } from 'react';
import { Stepper, StepLabel, Step, withStyles, Paper } from '@material-ui/core';

import { parseURL } from '../../sc-utilities';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import * as Yup from "yup";
import CustomerForm from './CustomerForm'
import UserForm from '../../sc-customer/Customer/UserForm'
import { connect } from "react-redux";
import * as customerActions from "../../sc-customer/Customer/store/customerActions"
import * as actions from "./actions"

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    }
});

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const CustomerRegistration = props => {
    const { classes } = props;
    const [activeStep, setActiveStep] = useState({ activeStep: 0, backValid: {} });
    const steps = ['Customer data', 'User data'];
    let translations = {};
    // First form
    const [result, setResult] = useState({ open: false, type: null, data: null, value: '', message: '', status: null, done: false, customer: {}, user: {}, everyThingDisabled: false });

    const [everyThingDisabled, setEverythingDisabled] = useState(false);
    const [backendError, setBackendError] = useState(null)

    const handleNext = async (form, key) => {
        setResult({ ...result, [`${key}`]: form })
        setActiveStep({ activeStep: activeStep.activeStep + 1, backValid: { [`${key}`]: true } });
    };

    const handleBack = (form, key) => {
        setResult({ ...result, [`${key}`]: form })
        setActiveStep({ ...activeStep, activeStep: activeStep.activeStep - 1 });
    };


    const handleUpload = event => {
        let file = event[0];
        if (!file) {
            setResult({ ...result, fileToSend: {}, fileName: '' });
            return
        }
        setResult({ ...result, file: file, fileName: file.name, value: URL.createObjectURL(file) });

    };
    //customer values
    let initialValuesCustomer = {
        Name: result.customer.Name || "",
        Namespace: result.customer.Namespace || "",
        StreetAddress: result.customer.StreetAddress || "",
        PostCode: result.customer.PostCode || "",
        City: result.customer.City || "",
        Country: result.customer.Country || "",
        VAT: result.customer.VAT || "",
        PasswordComplexity: result.customer.PasswordComplexity || 'securaze_basic'

    };

    let formSettingsCustomer = {
        Validation: {
            Name: Yup.string().required("Required"),
            Namespace: Yup.string()
                .trim()
                .matches(/^[a-z0-9_-]+$/, 'Is not in correct format')
                .required(),
            VAT: Yup.string().required("Required"),
            StreetAddress: Yup.string().required("Required"),
            PostCode: Yup.string().required("Required"),
            City: Yup.string().required("Required"),
            Country: Yup.string().required("Required"),
            PasswordComplexity: Yup.string().required("Required")
        },
        ButtonNext: {
            Title: translations["next"] || "Next",
            Color: 'primary'
        }

    };
    let initialValuesUser = {
        FirstName: result.user.FirstName || "",
        LastName: result.user.LastName || "",
        Username: result.user.Username || "",
        Email: result.user.Email || "",
        PhoneNumber: result.user.PhoneNumber || "",
        Password: "",
        RepeatPassword: "",
        UserStatus: result.user.UserStatus || 'active',
    };
    let formSettingsUser = {
        Validation: {
            FirstName: Yup.string().required("Required"),
            LastName: Yup.string().required("Required"),
            Username: Yup.string()
                .trim()
                .matches(/^[a-zA-Z0-9]+$/, 'Is not in correct format')
                .test('len', 'Must be different of ', val => val !== 'root')
                .required("Required"),
            Email: Yup.string().email('Invalid email').required("Required"),
            PhoneNumber: Yup.string().required("Required"),
            Password: Yup.string().required("Required"),
            RepeatPassword: Yup.string()
                .oneOf([Yup.ref('Password'), null], 'Passwords must match').required("Required"),
            UserStatus: Yup.string().required("Required")
        },
        ButtonSubmit: {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        },
        ButtonBack: {
            Title: translations["back"] || "Back",
        },
    };


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setResult({ ...result, open: false });
    };

    //Submit  customer  and user
    const handleSubmit = async formData => {
        setEverythingDisabled(true);
        let urlParams = parseURL(window.location.href);
        const formUser = { ...formData };
        let formCustomer = { ...result.customer };

        const Address = {
            StreetAddress: formCustomer.StreetAddress,
            City: formCustomer.City,
            PostCode: formCustomer.PostCode,
            Country: formCustomer.Country
        };

        const formSent = new FormData();
        formCustomer['Address'] = JSON.stringify(Address);
        delete formCustomer.StreetAddress;
        delete formCustomer.PostCode;
        delete formCustomer.Country;
        delete formCustomer.City;

        formSent.append('File', result.file)
        formSent.append("CustomerDetails", JSON.stringify(formCustomer));
        formSent.append("ID", urlParams.ID);
        formSent.append("UserDetails", JSON.stringify(formUser));
        let token = localStorage.getItem("SESSION");

        formSent.append("Token", token);

        let registerResult = await actions.registerUser(formSent);

        if (registerResult.status) {
            setResult({ ...result, open: true, message: `${registerResult.message} Redirecting to Securaze Dashboard...`, status: 'success', done: true });
            localStorage.clear();
            setTimeout(() => {
                window.location.href = '/login';
            }, 1500);
        } else {

            setBackendError(registerResult.errorKey)
            setResult({ ...result, open: true, message: `${registerResult.message}`, status: registerResult.error ? "error" : "warning", done: true });
            if (registerResult.errorKey === "Namespace") setActiveStep({ activeStep: 0, backValid: { [`customer`]: false } });
        }
    };

    function getStepContent(step) {
        switch (step) {
            case 0:
                return (
                    <CustomerForm
                        formSettings={formSettingsCustomer}
                        initialValues={initialValuesCustomer}
                        translations={translations}
                        handleNext={handleNext}
                        backValid={activeStep.backValid}
                        handleUpload={handleUpload}
                        imageValue={result.value}
                        backendError={backendError}
                        setBackendError={setBackendError}
                    ></CustomerForm>);
            case 1:
                return (<UserForm
                    formSettings={formSettingsUser}
                    initialValues={initialValuesUser}
                    everyThingDisabled={everyThingDisabled}
                    backValid={activeStep.backValid}
                    handleSubmit={handleSubmit}
                    handleBack={handleBack}
                    translations={translations}
                    handleNext={handleNext}
                    backendError={backendError}
                    setBackendError={setBackendError}
                ></UserForm>);
            default:
                return 'Unknown step';
        }
    }

    return <Paper className={classes.root}>
        <Stepper activeStep={activeStep.activeStep}>
            {steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};
                return (
                    <Step key={label} {...stepProps}>
                        <StepLabel {...labelProps}>{label}</StepLabel>
                    </Step>
                );
            })}

        </Stepper>
        {getStepContent(activeStep.activeStep)}

        <Snackbar open={result.open} autoHideDuration={6000} onClose={handleClose}>
            <Alert onClose={handleClose} severity={result.status}>
                {result.message}
            </Alert>
        </Snackbar>
    </Paper>
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onCheckFormParams: data => dispatch(customerActions.checkFormParams(data))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(CustomerRegistration));
